export default "__VITE_ASSET__BE69Ldb8__"